<template>
  <div class="pod">
    <div class="module1 f">
      <div class="box f-b-c">
        <div class="left">
          <div class="title">{{ $t('POD.Module1.Title1') }}</div>
          <div class="sub">{{ $t('POD.Module1.Sub1') }}</div>
          <div class="trait">
            <p><i class="el-icon-check"></i><span>{{ $t('POD.Module1.Easytouse') }}</span></p>
            <p><i class="el-icon-check"></i><span>{{ $t('POD.Module1.Unmatchedquality') }}</span></p>
            <p><i class="el-icon-check"></i><span>{{ $t('POD.Module1.Competitivepricing') }}</span></p>
          </div>
          <el-button class="btn" @click="jumpDesigner">{{ $t('POD.Module1.GetStarted') }}</el-button>
        </div>
        <div class="img">
          <oss-img :width="700" :height="630" src="https://img.kakaclo.com/web-img/home/pod/pic_img1.png" alt="img" />
        </div>
      </div>
    </div>
    <div class="module2">
      <div class="box">
        <div class="title1">{{ $t('POD.Module2.Title1')}}</div>
        <div class="sub1">{{ $t('POD.Module2.Sub1') }}</div>
        <div class="item f-b-c">
          <template v-if="isPC">
            <div class="left">
              <div class="title">{{ $t('POD.Module2.Title2') }}</div>
              <div class="sub">{{ $t('POD.Module2.Sub2') }}</div>
            </div>
            <div class="right">
              <oss-img :width="680" :height="340" src="https://img.kakaclo.com/web-img/home/pod/pic_img2.png" alt="img" />
            </div>
          </template>
          <template v-else>
            <div class="left">
              <oss-img :width="680" :height="340" src="https://img.kakaclo.com/web-img/home/pod/pic_img2.png" alt="img" />
            </div>
            <div class="right">
              <div class="title">{{ $t('POD.Module2.Title2') }}</div>
              <div class="sub">{{ $t('POD.Module2.Sub2') }}</div>
            </div>
          </template>
        </div>
        <div class="item f-b-c">
          <div class="left">
            <oss-img :width="680" :height="340" src="https://img.kakaclo.com/web-img/home/pod/pic_img3.png" alt="img" />
          </div>
          <div class="right">
            <div class="title">{{ $t('POD.Module2.Title3') }}</div>
            <div class="sub">{{ $t('POD.Module2.Sub3') }}</div>
            <div class="sub">{{ $t('POD.Module2.Sub4') }}</div>
          </div>
        </div>
        <div class="item f-b-c">
          <template v-if="isPC">
            <div class="left">
              <div class="title">{{ $t('POD.Module2.Title4') }}</div>
              <div class="sub">{{ $t('POD.Module2.Sub5') }}</div>
            </div>
            <div class="right">
              <oss-img :width="680" :height="340" src="https://img.kakaclo.com/web-img/home/pod/pic_img4.png" alt="img" />
            </div>
          </template>
          <template v-else>
            <div class="left">
              <oss-img :width="680" :height="340" src="https://img.kakaclo.com/web-img/home/pod/pic_img4.png" alt="img" />
            </div>
            <div class="right">
              <div class="title">{{ $t('POD.Module2.Title4') }}</div>
              <div class="sub">{{ $t('POD.Module2.Sub5') }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="module3">
      <div class="box">
        <div class="title1">{{ $t('POD.Module3.Title1') }}</div>
        <div class="sub1">{{ $t('POD.Module3.Sub1') }}</div>
        <div class="box1 f-b-c">
          <div class="left">
            <oss-img :width="680" :height="416" src="https://img.kakaclo.com/web-img/home/pod/pic_img5.png" alt="img" />
          </div>
          <div class="right">
            <div class="t1">
              <div class="title">{{ $t('POD.Module3.Title2') }}</div>
              <ul>
                <li class="sub">{{ $t('POD.Module3.Sub2') }}</li>
                <li class="sub">{{ $t('POD.Module3.Sub3') }}</li>
                <li class="sub">{{ $t('POD.Module3.Sub4') }}</li>
              </ul>
            </div>
            <div class="t1">
              <div class="title">{{ $t('POD.Module3.Title3') }}</div>
              <ul>
                <li class="sub">{{ $t('POD.Module3.Sub5') }}</li>
                <li class="sub">{{ $t('POD.Module3.Sub6') }}</li>
                <li class="sub">{{ $t('POD.Module3.Sub7') }}</li>
              </ul>
            </div>
            <div class="t2">
              <div class="sub" style="color:#303133">{{ $t('POD.Module3.Sub8') }}</div>
              <div class="sub">{{ $t('POD.Module3.Sub9') }}</div>
            </div>
          </div>
        </div>
        <div class="box2 f-b-c">
          <div class="item f-c-c">
            <img src="https://img.kakaclo.com/web-img/home/pod/icon_img1.png" alt="">
            <div class="sub"><b>77M+ </b>{{$t('POD.Module3.Sub10')}}</div>
          </div>
          <div class="item f-c-c">
            <img src="https://img.kakaclo.com/web-img/home/pod/icon_img2.png" alt="">
            <div class="sub"><b>99% </b>{{$t('POD.Module3.Sub11')}}</div>
          </div>
          <div class="item f-c-c">
            <img src="https://img.kakaclo.com/web-img/home/pod/icon_img3.png" alt="">
            <div class="sub"><b>1M+ </b>{{$t('POD.Module3.Sub12')}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="module4">
      <div class="box">
        <div class="title1">{{ $t('POD.Module4.Title1')}}</div>
        <div class="item f-b-c">
          <div class="left">
            <oss-img :width="740" :height="362" src="https://img.kakaclo.com/web-img/home/pod/pic_img6.png" alt="img" />
          </div>
          <div class="right">
            <img class="icon" src="https://img.kakaclo.com/web-img/home/pod/icon_img4.png" alt="">
            <div class="title2">{{ $t('POD.Module4.Title2')}}</div>
            <div class="sub">{{ $t('POD.Module4.Sub1')}}</div>
            <div class="sub">{{ $t('POD.Module4.Sub2')}}</div>
            <div class="user f--c">
              <div class="avatar">
                <oss-img :width="56" :height="56" src="https://img.kakaclo.com/web-img/home/pod/pic_img7.png" alt="img" />
              </div>
              <div>
                <div class="title3">{{ $t('POD.Module4.Title3')}}</div>
                <div class="sub" style="margin: 2px 0 0 0;">{{ $t('POD.Module4.Sub3')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module5">
      <promotion-blog :list="pod" :title="$t('POD.Module5.Title1')"></promotion-blog>
    </div>
    <promotion-module-1></promotion-module-1>
  </div>
</template>

<script>
import API from '@/api'
import PromotionBlog from '../components/PromotionBlog.vue'
import PromotionModule1 from '../components/PromotionModule1.vue'
export default {
  metaInfo: {
    title: 'Online Custom Apparel Design, Printing, and Dropshipping Service',
    meta: [
      {
        name: 'description',
        content: 'Explore our online custom clothing design and print-on-demand (POD) service tailored for dropshipping and e-commerce. Create unique designs and seamlessly integrate with your online store.'
      },
      {
        name: 'keyword',
        content: 'print-on-demand(POD), E-commerce, Dropshipping, Clothing customization'
      }
    ]
  },
  components: { PromotionBlog, PromotionModule1 },
  data() {
    return {
      pod: []
    }
  },
  created() {
    this.getPromotionLatestBlog()
  },
  methods: {
    getPromotionLatestBlog() {
      API.getPromotionLatestBlog().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.pod = res.data.POD
      })
    },
    jumpDesigner() {
      let path = `/podModel-list`
      location.href = path
    }
  }
}
</script>

<style lang="scss" scoped>
.pod {
  color: #606266;

  .box {
    max-width: 1400px;
    margin: 0 auto;
    padding: 16px;
    .title1 {
      font-size: .36rem;
      font-weight: 600;
      color: #303133;
      text-align: center;
      margin-bottom: 16px;
    }
    .sub1 {
      max-width: 870px;
      padding: 0 20px;
      font-size: 16px;
      text-align: center;
      margin: 0 auto;
      line-height: 24px;
    }
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .module1 {
    background-image: url('https://img.kakaclo.com/web-img/home/pod/bg_img1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-color: #fff;
    // height: 678px;
    padding-top: 48px;
    align-items: flex-end;
    .box {
      padding: 0 20px;
    }
    .left {
      width: 45%;
      flex-shrink: 0;
      padding-bottom: 10px;
      .title {
        // font-size: 48px;
        font-size: 0.48rem;
        margin-bottom: 16px;
        color: #303133;
        font-weight: bold;
      }
      .sub {
        font-size: .20rem;
        margin-bottom: 16px;
      }
      .trait {
        color: #9AC331;
        display: flex;
        flex-wrap: wrap;
        span {
          margin: 0 16px 0 3px;
        }
      }
      .btn {
        width: 168px;
        height: 56px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: bold;
        background: linear-gradient(90deg, #E7E140 0%, #9AC331 100%);
        color: #fff;
        margin-top: 80px;
      }
    }
    .img {
      width: 52%;
      height: auto;
    }
  }
  .module2 {
    padding: 104px 0;
    background-color: #fff;
    .item {
      margin-top: 80px;
      .title {
        font-size: 24px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 12px;
      }
      .sub {
        font-size: 16px;
        line-height: 24px;
      }
      .sub:nth-child(2) {
        margin-bottom: 10px;
      }
      .left,.right {
        width: 48.5%;
        height: auto;
        flex-shrink: 0;
      }
    }
    .item:nth-child(3) {
      margin-top:56px
    }
  }
  .module3 {
    padding: 104px 0;
    background-image: url('https://img.kakaclo.com/web-img/home/pod/bg_img2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .box1 {
      margin-top: 56px;
      .left,.right {
        width: 48.5%;
        height: auto;
        flex-shrink: 0;
        >img {
          width: 100%;
          height: 100%;
        }
      }
      .title {
        font-size: 24px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 12px;
      }
      .sub {
        font-size: 16px;
        font-size: 16px;
        line-height: 24px;
      }
      .t1{
        margin-bottom: 40px;
        ul {
          list-style: unset;
          padding-left: 20px;
        }
      }
      .t2 {
        color: #9AC331;
      }
    }
    .box2 {
      margin-top: 80px;
      .item {
        width: 30%;
        height: 168px;
        background-color: #fff;
        box-shadow: 0px 5px 5px -3px rgba(102,140,91,0.05), 0px 8px 10px 1px rgba(102,140,91,0.05), 0px 3px 14px 2px rgba(102,140,91,0.05);
        border-radius: 12px;
        flex-direction: column;
      }
      img {
        width: 56px;
        height: 56px;
        margin-bottom: 24px;
      }
    }
  }
  .module4 {
    padding: 104px 0;
    background-image: url('https://img.kakaclo.com/web-img/home/pod/bg_img3.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .title1 {
      color: #fff;
      margin-bottom: 56px;
    }
    .left {
      width: 53%;
      height: auto;
    }
    .right {
      width: 44%;
      border-radius: 12px;
      background-color: #fff;
      box-sizing: border-box;
      padding: 32px;
      .icon {
        width: 66px;
        height: 48px;
        margin-bottom: 18px;
      }
      .title2 {
        color: #303133;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 16px;
        line-height: 32px;
      }
      .title3 {
        color: #303133;
        font-size: 16px;
        line-height: 24px;
      }
      .sub {
        color: #909399;
        font-size: 16px;
        line-height: 24px;
      }
      .sub:nth-child(4) {
        margin-bottom: 28px;
      }
      .avatar {
        width: 56px;
        height: 56px;
        margin-right: 8px;
      }
    }
  }
  .module5 {
    background-color: #fff;
    padding: 104px 0;
  }

  @media screen and (max-width: 1000px) {
    .box {
      padding: 0 16px;
      .title1 {
        font-size: 20px;
        line-height: 28px;
      }
      .sub1 {
        font-size: 14px;
        line-height: 22px;
      }
    }
    .module1 {
      background-image: url('https://img.kakaclo.com/web-img/home/pod/bg_img5.png');
      .box {
        display: flex;
        flex-direction: column;
        text-align: center;
        .left {
          width: unset;
          .title {
            font-size: 28px;
            line-height: 36px;
            margin-bottom: 12px;
          }
          .sub {
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 12px;
          }
          .trait {
            display: flex;
            justify-content: center;
            p {
              margin-bottom: 8px;
            }
          }
          .btn {
            margin-top: 40px;
            width: 132px;
            height: 40px;
            font-size: 16px;
          }
        }
        .img {
          width: 100%;
          margin-top: 30px;
        }
      }
    }
    .module2 {
      padding: 48px 0;
      .box {
        .item {
          margin-top: 26px;
          flex-direction: column;
          .title {
            font-size: 16px;
            line-height: 24px;
            font-weight: 600;
          }
          .sub {
            font-size: 12px;
            line-height: 18px;
          }
          .left,.right {
            width: 100%;
            img {
              margin-bottom: 10px;
            }
            .title {
              margin-bottom: 8px;
            }
          }
        }
      }
    }
    .module3 {
      padding: 48px 0;
      .box1 {
        flex-direction: column;
        margin-top: 32px;
        .left,.right {
          width: 100%;
          img {
            margin-bottom: 12px;
          }
        }
        .t1 {
          margin-bottom: 16px;
        }
        .title {
          font-size: 16px;
          margin-bottom: 10px;
        }
        .sub {
          font-size: 12px;
          line-height: 18px;
        }
      }
      .box2 {
        margin-top: 40px;
        flex-direction: column;
        .item {
          width: 100%;
          height: 138px;
          margin-bottom: 28px;
          color: #909399;
          b {
            color: #303133;
          }
          img {
            margin-bottom: 12px;
          }
        }
        .item:last-child {
          margin: 0;
        }
      }
    }
    .module4 {
      padding: 48px 0;
      background:#124537;
      .box{
        .title1 {
          margin-bottom: 32px;
        }
        .item {
          flex-direction: column;
          .left,.right {
            width: 100%;
          }
          .left {
            margin-bottom: 20px;
          }
          .right {
            padding: 24px;
            .title2 {
              font-size: 16px;
              line-height: 24px;
              margin-bottom: 12px;
            }
            .sub {
              font-size: 12px;
              line-height: 18px;
            }
            .sub:nth-child(4) {
              margin-bottom: 24px;
            }
            .avatar {
              width: 32px;
              height: 32px;
            }
            .title3 {
              font-size: 12px;
              line-height: 14px;
            }
          }
        }
      }
    }
    .module5 {
      padding: 48px 0;
      // .box {
      //   .title1 {
      //     margin-bottom: 28px;
      //   }
      //   .box1 {
      //     flex-wrap: wrap;
      //     .item {
      //       width: 48%;
      //       .img {
      //         margin-bottom: 4px;
      //       }
      //     }
      //     .type {
      //       height: 28px;
      //       padding: 0 12px;
      //       border-radius: 20px;
      //       background-color: #F7F8FB;
      //       margin-bottom: 4px;
      //     }
      //     .title {
      //       font-size: 14px;
      //       line-height: 22px;
      //       margin-bottom: 2px;
      //     }
      //     .foot {
      //       flex-direction: column;
      //       align-items: flex-start;
      //       .date {
      //         font-size: 12px;
      //         line-height: 18px;
      //       }
      //       .more {
      //         font-size: 13px;
      //         margin-bottom: 10px;
      //       }
      //     }
      //   }
      // }
    }
  }
}
</style>
